export default {
  signUpSuccess: 'Succesfully registered! You\'ve been signed in as well.',
  signUpFailure: 'Registration failed. Email may be taked, or passwords don\'t'
                  + ' match.',
  signInSuccess: 'Welcome!',
  signInFailure: 'Failed to sign in. Check your email and password and try' +
                  ' again.',
  signOutSuccess: 'Come back soon!',
  changePasswordSuccess: 'Password changed successfully!',
  changePasswordFailure: 'Failed to change passwords. Check your old password' +
                         ' and try again.',
  createPostSuccess: 'Your post has been successfully created!',
  createProfileSuccess: 'Your profile has been successfully created!',
  createProfileSuccessE: 'Your company profile has been successfully created!',
  editProfileSuccess: 'Your profile has been successfully updated!',
  bookmarkSuccess: 'You have bookmarked this awesome job post!',
  removeJobSuccess: 'You have deleted this awesome job post!',
  removeBookmarkSuccess: 'You have removed this bookmark!',
  editPostSuccess: 'Your post has been successfully updated!'
}



// WEBPACK FOOTER //
// ./src/auth/messages.js